<template>
  <div id="app">
    <!-- Note by Will
    Matt, I'm gonna try somethign a little different here.
    I'm gonna just load every page, and then let each page
    decide whether it should be visible or not based on the
    current URL. That way we have everything initialized up
    front, so there should be fewer surprises / glitches during
    page navigation. -->
    <home-page></home-page>
    <playlist-page playlist="fountain"></playlist-page>
    <playlist-page playlist="plaza"></playlist-page>
    <inductee-page></inductee-page>
    <inductee-details-page></inductee-details-page>
    <device-page></device-page>
    <form id="post-form" enctype="application/x-www-form-urlencoded">
      <input type="hidden" name="_METHOD" value="PUT">
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const ax = axios.create({
  baseURL: '//api.classicalwof.org/restApp.php'
})

Vue.use(require('vue-cookie'))

Vue.component('sprite-button', require('./components/sprite-button.vue'))
Vue.component('picker-modal', require('./components/picker-modal.vue'))
Vue.component('external-link', require('./components/external-link.vue'))

export default {
  name: 'App',
  data () {
    return {
      route: [ 'HomePage' ],
      routeHistory: [],
      fullInductees: [],
      inductees: [],
      fountain: [],
      plaza: [],
      device: [],
      deviceAudioPaused: true,
      deviceAudioSrc: '',
      audio: new Audio()
    }
  },
  components: {
    'home-page'  : require('./views/HomePage.vue'),
    'playlist-page'  : require('./views/PlaylistPage.vue'),
    'inductee-page'  : require('./views/InducteePage.vue'),
    'inductee-details-page'  : require('./views/InducteeDetailsPage.vue'),
    'device-page'  : require('./views/DevicePage.vue'),
  },
  created () {
    // Get data
    this.fetchInductees()
    this.fetchFountain()
    this.fetchPlaza()
    if (navigator.serviceWorker) {
      navigator.serviceWorker.register('/good-enough-sw.js')
    }
  },
  methods: {
    goto (...route) {
      this.routeHistory.push(this.route)
      this.route = route
    },
    back () {
      this.route = this.routeHistory.pop()
    },
    nowPlaying (array) {
      if (this[array].length > 0) {
        return this[array][0]
      } else {
        return {
          InducteeName: '',
          MusicTitle: '',
          ImageURL: '',
          WebMusicFile: '',
        }
      }
    },
    fetchInductees () {
      ax.get('/inductees/music')
      .then(result => {
        let inductees = result.data
        // Sort by last name.
        inductees.sort((a, b) => a.InducteeName.localeCompare(b.InducteeName))
        // Replace the inductees array in a way that makes Vue happy
        this.inductees.splice(0, this.inductees.length, ...inductees)
      })
      .catch(err => {
        console.log(err)
      })
    },
    fetchFountain () {
      ax.get('/fountain?' + (new Date).valueOf())
      .then(result => {
        // Replace the inductees array in a way that makes Vue happy
        this.fountain.splice(0, this.fountain.length, ...result.data)
      })
      .catch(err => {
        console.log(err)
      })
    },
    fetchPlaza () {
      ax.get('/plaza?' + (new Date).valueOf())
      .then(result => {
        // Replace the inductees array in a way that makes Vue happy
        this.plaza.splice(0, this.plaza.length, ...result.data)
      })
      .catch(err => {
        console.log(err)
      })
    },
    fetchFullInductee (id) {
      ax.get('/full-inductees/' + id)
      .then(result => {
        // Replace the inductees array in a way that makes Vue happy
        Vue.set(this.fullInductees, id, result.data[0])
      })
      .catch(err => {
        console.log(err)
      })
    },
    queue ({playlist, inductee}) {
      switch(playlist)
      {
          case 'device':
            this.playOnDevice(inductee)
          break
          case 'plaza':
            ax.post('/plaza',JSON.stringify({ InducteeID: inductee.InducteeID }),
                   {
                   headers: {"Content-Type": "application/x-www-form-urlencoded"}
                   }).then(this.fetchPlaza.bind(this));
          break
          case 'fountain':
            ax.post('/fountain',JSON.stringify({ InducteeID: inductee.InducteeID }),
                   {
                   headers: {"Content-Type": "application/x-www-form-urlencoded"}
                 }).then(this.fetchFountain.bind(this));
          break
        }
    },
    bump ({playlist, inductee}) {
      switch(playlist)
      {
          case 'device':
            this.playOnDevice(inductee)
          break
          case 'plaza':
            fetch('//api.classicalwof.org/restApp.php/plaza/' + inductee.PlazaPlaylistID, {
              method: 'post',
              mode: 'no-cors',
              headers: {
                'X-Http-Method-Override': 'PUT'
              },
              body: new FormData(document.getElementById('post-form'))
            }).then(this.fetchPlaza.bind(this))
          break
          case 'fountain':
            fetch('//api.classicalwof.org/restApp.php/fountain/' + inductee.FountainPlaylistID, {
              method: 'post',
              mode: 'no-cors',
              headers: {
                'X-Http-Method-Override': 'PUT'
              },
              body: new FormData(document.getElementById('post-form'))
            }).then(this.fetchFountain.bind(this))
          break
        }
    },
    playOnDevice (inductee) {
      this.deviceAudioPaused = false
      this.deviceAudioSrc = '//api.classicalwof.org/media/MediaSmall/' + inductee.WebMusicFile
      this.audio.src = this.deviceAudioSrc
      this.audio.play()

      if ('mediaSession' in navigator) {
        navigator.mediaSession.metadata = new MediaMetadata({
          title: inductee.MusicTitle,
          artist: inductee.InducteeName,
          // album: 'Whenever You Need Somebody',
          artwork: [
            { src: '//classicalwalkoffame.org/inductees/' + inductee.ImageURL },
          ]
        });
        navigator.mediaSession.setActionHandler('play', () => { this.togglePauseOnDevice() });
        navigator.mediaSession.setActionHandler('pause', () => { this.togglePauseOnDevice() });
        // navigator.mediaSession.setActionHandler('seekbackward', function() {});
        // navigator.mediaSession.setActionHandler('seekforward', function() {});
        // navigator.mediaSession.setActionHandler('previoustrack', function() {});
        // navigator.mediaSession.setActionHandler('nexttrack', function() {});
      }

      // A relic of the playlist thing
      this.device.splice(0, this.device.length, inductee)
    },
    playRadioTour (inductee) {
      this.deviceAudioPaused = false
      this.deviceAudioSrc = inductee.RadioTour
      this.audio.src = this.deviceAudioSrc
      this.audio.play()
      // A relic of the playlist thing
      this.device.splice(0, this.device.length, inductee)
    },
    togglePauseOnDevice () {
      this.deviceAudioPaused = ! this.deviceAudioPaused
      if (this.deviceAudioPaused) {
        this.audio.pause()
      } else {
        this.audio.play()
      }
    },
    stopOnDevice () {
      if (this.route[0] === 'DevicePage') this.goto('HomePage') // lazy hack
      this.device=[]
      this.deviceAudioSrc = ''
      this.deviceAudioPaused = true
      this.audio.src = this.deviceAudioSrc
    }
  }
}
</script>

<style lang="less">
html,
body {
  margin: 0;
  padding: 0;
  border: 0;
  width: 100%;
  height: 100%;
  background: url(img/bg.jpg) no-repeat top left;
  background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  -webkit-overflow-scrolling: touch;
}
body {
  font-family: "myriad-pro", arial, sans-serif;
}
a {
  text-decoration: none;
  cursor: pointer;
}
</style>